import { userSession } from '@/api/modules/login.api.js';
import Config from '@/services/config.service';
const appConfig = new Config();

export default [
  {
    path: '',
    // redirect: { name: 'Home' },  ==> IT DOES NOT WORK!
    beforeEnter: (to, from, next) => {
      return next(`${to.path}home/`);
    }
  },
  {
    path: 'home',
    name: 'Home',
    component: () => import('./views/Home.vue'),
  },
  // Données
  {
    path: 'data',
    name: 'Data',
    component: () => import('./views/Data.vue'),
    beforeEnter: (to, from, next) => {
      if (userSession.isSuperuser()) {
        return next();
      }
      if (appConfig.isSaas) {
        return next({ name: 'Datasets' });
      }
      if (userSession.isDelegatedAdmin() || userSession.isEditor()) {
        return next({ name: 'Datasets' });
      }
      return next({ name: '403Page' });
    },
  },
  // Others
  {
    path: 'access-denied/',
    name: '403Page',
    component: () => import('./views/403Page.vue'),
  },
  {
    path: 'not-found/',
    name: 'NotFound',
    component: () => import('./views/NotFound.vue'),
  },
];
